// extracted by mini-css-extract-plugin
export default {"value_text":"ValueText_value_text__Dogcs","value_text_little":"ValueText_value_text_little__ggM06","frac_text":"ValueText_frac_text__01+Tl","wrapper":"ValueText_wrapper__OQJ7I"};